import { Record } from 'immutable';
export const makeErrorTranslation = Record({
  title: '',
  description: '',
  validationError: false,
  showTID: false,
  actions: null
});